'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signup = undefined;

var _reduxFormSaga = require('redux-form-saga');

var signup = exports.signup = (0, _reduxFormSaga.createFormAction)('signup');